import { Box, Button, CircularProgress, Grid, Typography } from '@mui/material';
import Image from 'next/image';
import MuiTextField3 from '@/components/TextField3';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { registerUser } from '@/store/actions';
import { useState } from 'react';
import { palette } from '@/theme/constants';

const UserDetailsStep = ({ formik, onBack }: any) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const { values, handleChange, errors, touched, setFieldTouched, validateField } = formik;
  const [Loading, SetLoading] = useState(false);

  const handleBlur = (field: string) => {
    setFieldTouched(field, true);
    validateField(field);
  };
  const handleSubmit = (data: any) => {
    data.email = data.email.toLowerCase();
    const { confirm_password, ...formValues } = data;
    SetLoading(true);
    if (router?.asPath?.includes('invitation')) {
      dispatch(registerUser({ ...formValues, invitation: router?.query?.invitation }));
    } else {
      dispatch(registerUser(formValues));
    }
  };

  return (
    <>
      {/* Loading Overlay */}
      {Loading && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 10,
            borderRadius: '0.6rem',
          }}>
          <CircularProgress sx={{ color: palette.primary }} />
        </Box>
      )}
      <Box width='100%' maxWidth='33rem' textAlign='center'>
        <Box mb={2}>
          <Image priority src='/images/logo-new.svg' width={66} height={34} alt='memvy' />
        </Box>
        <Typography mb={2} color='black' fontSize='1.5rem'>
          We just need a few more details.
        </Typography>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(values);
          }}>
          <Grid container width='100%' marginBottom='0.5rem' rowSpacing={2}>
            <Grid item xs={12}>
              <Typography align='left' color='black' fontSize={'1rem'}>
                First Name
              </Typography>
              <MuiTextField3
                id='name'
                name='name'
                fullWidth
                required
                placeholder='Enter your first name'
                onBlur={() => handleBlur('name')}
                onChange={handleChange}
                value={values.name}
                error={Boolean(errors.name && touched.name)}
                errorMessage={errors.name}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography align='left' color='black' fontSize={'1rem'}>
                Last Name
              </Typography>
              <MuiTextField3
                id='lastname'
                name='lastname'
                fullWidth
                required
                placeholder='Enter your last name'
                onBlur={() => handleBlur('lastname')}
                onChange={handleChange}
                value={values.lastname}
                error={Boolean(errors.lastname && touched.lastname)}
                errorMessage={errors.lastname}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography align='left' color='black' fontSize={'1rem'}>
                Phone Number
              </Typography>{' '}
              <MuiTextField3
                id='phonenumber'
                name='phonenumber'
                fullWidth
                required
                placeholder='Enter your phone number'
                onBlur={() => handleBlur('phonenumber')}
                onChange={handleChange}
                value={values.phonenumber}
                error={Boolean(errors.phonenumber && touched.phonenumber)}
                errorMessage={errors.phonenumber}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography align='left' color='black' fontSize={'1rem'}>
                Referral Code (Optional)
              </Typography>
              <MuiTextField3
                id='referralCode'
                name='referralCode'
                fullWidth
                placeholder='Enter a referral code'
                onBlur={() => handleBlur('referralCode')}
                onChange={handleChange}
                value={values.referralCode}
                error={Boolean(errors.referralCode && touched.referralCode)}
                errorMessage={errors.referralCode}
              />
            </Grid>
          </Grid>

          <Button
            type='submit'
            variant='contained'
            fullWidth
            sx={{ height: '60px', borderRadius: '0.6rem', fontSize: '1rem', backgroundColor: '#212D6D', mt: 2 }}>
            <Typography mr={2} variant='button'>
              Finish Sign Up
            </Typography>
          </Button>
        </form>
      </Box>
    </>
  );
};

export default UserDetailsStep;
